import Paper from "@mui/material/Paper";
import TextField from "components/TextFieldInput";
import { PROP_TYPES, DEFAULT_STATE } from "pages/order/prop-types";
import { StyledShipTo, ShipToRow, WorkOrderHeading } from "styles/pages/order";

const DecoratorWorkOrderShipTo = ({ state, setState }) => {
  const shipTo = state?.shipTo;

  return (
    <Paper elevation={3}>
      <WorkOrderHeading>Ship To</WorkOrderHeading>
      <StyledShipTo>
        <ShipToRow>
          <TextField
            label="Ship Name"
            error={!shipTo?.shipName?.trim()}
            value={shipTo?.shipName}
            handleChange={(e) =>
              setState({
                ...state,
                shipTo: { ...shipTo, shipName: e?.target?.value },
              })
            }
          />
        </ShipToRow>

        <ShipToRow>
          <TextField
            label="Address 1"
            error={!shipTo?.address1?.trim()}
            value={shipTo?.address1}
            handleChange={(e) =>
              setState({
                ...state,
                shipTo: { ...shipTo, address1: e?.target?.value },
              })
            }
          />

          <TextField
            label="Address 2"
            value={shipTo?.address2}
            handleChange={(e) =>
              setState({
                ...state,
                shipTo: { ...shipTo, address2: e?.target?.value },
              })
            }
          />
        </ShipToRow>

        <ShipToRow style={{ marginBottom: 0 }}>
          <TextField
            label="City"
            error={!shipTo?.city?.trim()}
            value={shipTo?.city}
            handleChange={(e) =>
              setState({
                ...state,
                shipTo: { ...shipTo, city: e?.target?.value },
              })
            }
          />

          <TextField
            label="State"
            error={!shipTo?.state?.trim()}
            value={shipTo?.state}
            handleChange={(e) =>
              setState({
                ...state,
                shipTo: { ...shipTo, state: e?.target?.value },
              })
            }
          />

          <TextField
            label="Country"
            error={!shipTo?.country?.trim()}
            value={shipTo?.country}
            handleChange={(e) =>
              setState({
                ...state,
                shipTo: { ...shipTo, country: e?.target?.value },
              })
            }
          />

          <TextField
            label="Zip"
            error={!shipTo?.zip?.trim()}
            value={shipTo?.zip}
            handleChange={(e) =>
              setState({
                ...state,
                shipTo: { ...shipTo, zip: e?.target?.value },
              })
            }
          />
        </ShipToRow>
      </StyledShipTo>
    </Paper>
  );
};

DecoratorWorkOrderShipTo.propTypes = PROP_TYPES;

DecoratorWorkOrderShipTo.defaultProps = DEFAULT_STATE;

export default DecoratorWorkOrderShipTo;
